import React from 'react';

interface ButtonProps {
    className: string;
    filled?: boolean;
    round?: boolean;
    color?: string;
    textColor?: string;
    icon?: string;
    iconPosition?: string;
    textPosition?: string;
    size?: string;
}

const Button = (props) => {
    let buttonProps = {};

    if (props.onClick) {
        buttonProps.onClick = props.onClick;
    }

    if (props.link) {
        buttonProps.href = props.link;
    }

    buttonProps.className = 'button' +
        (props.className ? ` ${props.className}` : '') +
        (props.enabled ? `` : ' disabled') +
        (props.filled ? ' filled' : '') +
        (props.round ? ' round' : '') +
        (props.simple ? ' simple' : '') +
        (props.bold ? ' bold' : '') +
        (props.color ? ` color-${props.color}` : '') +
        (props.bgColor ? ` bg-${props.bgColor}` : '') +
        (props.borderColor ? ` border-${props.borderColor}` : '') +
        (props.textColor ? ` text-${props.textColor}` : '') +
        (props.icon ? ' has-icon' : '') +
        (props.iconPosition ? ` icon-${props.iconPosition}` : '') +
        (props.textPosition ? ` text-${props.textPosition}` : '') +
        (props.size ? ` size-${props.size}` : '');

    const style = {};
    if (props.minWidth) {
        style.minWidth = props.minWidth;
    }

    const element = React.createElement(
        (props.link ? 'a' : 'div'),
        buttonProps,
        <>
            <div className="inner" style={style}>{props.children}</div>
            {props.icon ? <div className="icon">{props.icon}</div> : undefined}
        </>
    );

    return element;
}

export default Button